import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DataStoreFacade, UIFacade } from '../facades';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CommonDataResolver implements Resolve<boolean> {
  constructor(private service: DataStoreFacade, private uiFacade: UIFacade) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.service.load().pipe(
      catchError((error: any, caught: Observable<any>) => {
        this.uiFacade.handleErrorPage(error);
        return of(null);
      })
    );
  }
}
